import React from "react";
import { useNavigate } from "react-router-dom";

const VerifyProductSection = () => {
    const navigate = useNavigate();

    const handleVerifyClick = () => {
        const url = process.env.REACT_APP_VERIFY_PAGE_URL || "https://verify.elystrion.com/";
        window.open(url, "_blank");
    }

    return (
        <section className="h-screen bg-[rgba(15,15,15,1)] pt-[60px] pb-[60px] xl:pt-[120px] xl:pb-[120px]" id="verify">
            <div className="inner-wrap max-w-[1700px] m-auto m-0 xl:pt-[0] xl:pb-[0] pl-[10px] pr-[10px] lg:pl-[25px] lg:pr-[25px] xl:pl-[50px] xl:pr-[50px]">
                <div className="content-block flex gap-9 xl:rounded-3xl p-12 items-center">
                    <p className="tag-line">
                        <h2 className="text-[#f3daa3] text-[24px] sm:text-[24px] md:text-[30px] uppercase pb-[30px]">
                            Verify your product
                        </h2>
                        <h3 className="font-semi-bold text-[#CACACA] text-[32px] sm:text-[46px] md:text-[72px] adjust-width">
                            Is your product real?</h3>
                        <h4 className="font-semi-bold text-[#CACACA] text-[24px] sm:text-[28px] md:text-[32px] adjust-width">
                            Check its authenticity with Elystrion now</h4>
                        <button className="grey" onClick={handleVerifyClick}>
                            <span>Verify</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect width="24" height="24" rx="12" fill="black" />
                                <path d="M17 7L7 17M17 7H8M17 7V16" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </p>
                </div>
            </div>

        </section>
    );
};

export default VerifyProductSection;